import React, {useEffect, useState} from 'react';
import {logo, smallLogo} from '../../../Resource/images';
import {Menu, Layout, Button, Dropdown, Tooltip} from 'antd';
import {
  BookOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  FileOutlined,
  FileZipOutlined,
  HistoryOutlined,
  KeyOutlined,
  MailOutlined,
  PartitionOutlined,
  ScheduleOutlined,
  SettingOutlined,
  SolutionOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  TransactionOutlined,
  VideoCameraAddOutlined,
} from '@ant-design/icons';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import Logout from '../../../Assets/Log-out.svg';
import {useJWTAuthActions} from '../../../Api/JWTAuthProvider';
import {getUserDetails, setSidebarState} from '../../../Store/Actions';
import {useDispatch, useSelector} from 'react-redux';
import {urlModuleMapper} from '../../../permissions';
import {usePermissions} from '../../../hooks/usePermission';
const {Sider} = Layout;

const items = [
  {
    id: 'events-1',
    label: 'Events',
    key: 'events',
    icon: <EnvironmentOutlined />,
  },

  {
    id: 'jobs-2',
    label: 'Jobs',
    key: 'jobs',
    icon: <SolutionOutlined />,
  },
  {
    id: 'ads-3',
    label: 'Ads',
    key: 'ads',
    icon: <VideoCameraAddOutlined />,
  },

  {
    id: 'sponsors-4',
    label: 'Sponsors',
    key: 'sponsors',
    icon: <TeamOutlined />,
  },

  {
    id: 'users-6',
    label: 'Member Attendees',
    key: 'memberAttendees',
    icon: <UserOutlined />,
    // disabled: true,
  },
  {
    id: 'registrationHistory-6b',
    label: 'Registration History',
    key: 'registrationHistory',
    icon: <HistoryOutlined />,
  },
  {
    id: 'emailRemember-7',
    label: 'Email To Members',
    key: 'emailToMembers',
    icon: <MailOutlined />,
  },
  {
    id: 'allEmailScheduler-5',
    label: 'All Email Scheduler',
    key: 'allEmailScheduler',
    icon: <ScheduleOutlined />,
  },
  {
    id: 'allRefund-23',
    label: 'All Refund',
    key: 'allRefund',
    icon: <TransactionOutlined />,
  },
  {
    id: 'specialPayment-8',
    label: 'Special Payment',
    key: 'specialPayment',
    icon: <DollarOutlined />,
  },

  {
    id: 'masters-9',
    label: 'Masters',
    key: 'Sponsorship',
    icon: <SettingOutlined />,
    key: 'masters',
    children: [
      {
        id: 'chapters-10',
        label: 'Chapters',
        key: 'chapters',
        icon: <BookOutlined />,
      },
      {
        id: 'pbssinternational-11',
        label: 'PBSS International',
        key: 'pbssInternational',
        icon: <BookOutlined />,
      },
      {
        id: 'jobFees-12',
        label: 'Job Fees',
        key: 'jobfees',
        icon: <DollarOutlined />,
      },
      {
        id: 'adFees-13',
        label: 'Ad Fees',
        key: 'adfees',
        icon: <DollarOutlined />,
      },
      {
        id: 'interests-14',
        label: 'Interests',
        key: 'interests',
        icon: <KeyOutlined />,
      },

      {
        id: 'emailTemplates-15',
        label: 'Email Templates',
        key: 'emailTemplates',
        icon: <MailOutlined />,
      },
      {
        id: 'companies-16',
        label: 'Companies',
        key: 'companies',
        icon: <PartitionOutlined />,
      },
      {
        id: 'couponCodes-17',
        label: 'Coupon Codes',
        key: 'couponCodes',
        icon: <FileZipOutlined />,
      },

      {
        id: 'eventTypes-18',
        label: 'Event Types',
        key: 'eventTypes',
        icon: <EnvironmentOutlined />,
      },

      {
        id: 'committeeMember-19',
        label: 'Committee Member',
        key: 'committeeMember',
        icon: <UsergroupAddOutlined />,
      },
      {
        id: 'stem-20',
        label: 'STEM',
        key: 'stem',
        icon: <VideoCameraAddOutlined />,
      },
      {
        id: 'industry-21',
        label: 'Industry News',
        key: 'industry',
        icon: <VideoCameraAddOutlined />,
      },
      {
        id: 'careerMentorship-20',
        label: 'Career Mentorship',
        key: 'careerMentorship',
        icon: <SolutionOutlined />,
      },
      {
        id: 'pbssFiles-22',
        label: 'Files',
        key: 'pbssFiles',
        icon: <FileOutlined />,
      },
    ],
  },
];

const SideBarMenu = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const dispatch = useDispatch();
  const [selectedRole, setSelectedRole] = useState('Admin');
  const [selectedMenuItem, setSelectedMenuItem] = useState('mail');
  const {sideBarState} = useSelector(({chapters}) => chapters);
  const {userDetails} = useSelector(({users}) => users);
  const userInfo = localStorage.getItem('userInfo');
  const user = JSON.parse(userInfo);
  const userRole = user?.role || null;
  const {checkPermission} = usePermissions(userRole);
  const allModulesWithNoPermissions = checkPermission();
  const mappedAllModulesWithNoPermissions = allModulesWithNoPermissions.map(
    (item) => urlModuleMapper[item],
  );

  const filterNavItems = items.filter((item) => {
    const isItemInclude = mappedAllModulesWithNoPermissions.includes(item.key);
    return !isItemInclude;
  });
  const navItems = filterNavItems;
  useEffect(() => {
    if (!userDetails.data) {
      dispatch(getUserDetails());
    }
  }, [userDetails.data]);

  const onMenuItemClick = (e) => {
    setSelectedMenuItem(e.key);
    navigate(`/admin/${e.key}`);
  };
  const {logout} = useJWTAuthActions();

  const handleLogoutClick = () => {
    logout();
  };

  const handalCollaped = (value) => {
    dispatch(setSidebarState(value));
  };
  const urlToMenuKeyMap = [
    {
      match: 'eventEmailTemplatesScheduler',
      key: 'events',
    },
    {
      match: 'eventEmailTemplate',
      key: 'events',
    },
  ];

  const getForcedMenuKey = (url) => {
    for (const rule of urlToMenuKeyMap) {
      if (url.includes(rule.match)) {
        return rule.key;
      }
    }
    return null;
  };

  const findSelectedMenuItem = (navItems, url) => {
    for (const item of navItems) {
      if (url.includes(item.key)) {
        return item.key;
      } else if (item.children) {
        const childResult = findSelectedMenuItem(item.children, url);
        if (childResult) {
          return childResult;
        }
      }
    }
    return null;
  };

  const getParentKeyOfSelected = (navItems, selectedKey) => {
    if (!selectedKey) return null;
    for (const item of navItems) {
      if (item.children && item.children.some((c) => c.key === selectedKey)) {
        return item.key;
      }
    }
    return null;
  };

  const parentKeyOfSelected = getParentKeyOfSelected(
    navItems,
    selectedMenuItem,
  );

  const handleSelectChange = (value) => {
    setSelectedRole(value);
    if (value === 'admin') {
      navigate('/admin/events');
    } else if (value === 'user') {
      navigate('/');
    }
  };

  useEffect(() => {
    const url = location.pathname.replace('/admin/', '');
    const forcedKey = getForcedMenuKey(url);
    if (forcedKey) {
      setSelectedMenuItem(forcedKey);
      return;
    }
    const selectedMenuItem = findSelectedMenuItem(navItems, url);
    if (selectedMenuItem) {
      setSelectedMenuItem(selectedMenuItem);
    }
  }, [location]);

  useEffect(() => {
    const userRole = localStorage.getItem('userInfo');
    if (userRole?.role === 'admin') {
      setSelectedRole('admin');
    } else if (userRole?.role === 'user') {
      setSelectedRole('user');
    }
  }, []);

  const menu = (
    // <Menu>
    //   <Select
    //     id='user-select'
    //     prefixCls='chapter-extend-collapse'
    //     showSearch={false}
    //     optionFilterProp='children'
    //     placeholder={'Select'}
    //     // options={[
    //     //   {label: 'Admin', value: 'admin'},
    //     //   {label: 'Switch to User View', value: 'user'},
    //     // ]}
    //     suffixIcon={<CaretDownOutlined />}
    //     prefixIcon={<UserOutlined />}
    //     value={selectedRole}
    //     // onChange={handleSelectChange}
    //   >
    //     <option value='admin'>Admin</option>
    //     <option value='user'>Switch to User View</option>
    //   </Select>
    //   {/* Add more Menu.Items for additional options if needed */}
    // </Menu>

    // <Link to={'/'}>
    //   <UserOutlined />
    // </Link>
    <span></span>
  );

  return (
    <Sider
      prefixCls='menu-sidebar-component'
      collapsible
      collapsed={sideBarState}
      onCollapse={(value) => handalCollaped(value)}
      theme='light'>
      <div className='demo-logo-vertical'>
        <Link to='/'>
          <img
            className={sideBarState ? 'small-logo' : 'header-logo text-center'}
            src={sideBarState ? smallLogo : logo}
            alt='logo'
          />
        </Link>
      </div>
      <Menu
        id={navItems.id}
        defaultSelectedKeys={['1']}
        selectedKeys={[selectedMenuItem]}
        prefixCls={sideBarState ? 'sidebar-menu-mini' : 'sidebar-menu'}
        theme='light'
        mode='inline'>
        {navItems.map((item) => {
          return item.children ? (
            <Menu.SubMenu
              key={item.key}
              icon={item.icon}
              title={item.label}
              className={
                parentKeyOfSelected === item.key
                  ? 'sidebar-submenu-parent-active'
                  : ''
              }>
              {item.children.map((child) => (
                <Menu.Item key={child.key} icon={child.icon}>
                  <Link to={`/admin/${child.key}`}>{child.label}</Link>
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          ) : (
            <Menu.Item key={item.key} icon={item.icon}>
              <Link to={`/admin/${item.key}`}>{item.label}</Link>
            </Menu.Item>
          );
        })}
      </Menu>
      <div
        className={`sidebar-botton-container ${
          sideBarState ? 'sidebar-extend-mini' : ''
        }`}>
        {/* <Button onClick={'add your function here !'}>
          <img src={AccoutSettings} />
          {sideBarState ? '' : 'Profile Settings'}
        </Button> */}

        {!sideBarState ? (
          <Link to={'/'} className='switch-to-user-link'>
            <Button id='adminSide-switch-to-user-view' type='default'>
              Switch to User View
            </Button>
          </Link>
        ) : (
          <Tooltip placement='right' title='Switch to User View'>
            <Dropdown overlay={menu} placement='bottomCenter'>
              <Link to={'/'} className='switch-to-user-link-collapsed'>
                <Button type='default'>
                  <UserOutlined />
                </Button>
              </Link>
            </Dropdown>
          </Tooltip>
        )}
        <Link
          to={'/login'}
          className={
            sideBarState
              ? 'switch-to-user-link-collapsed'
              : 'switch-to-user-link'
          }>
          {sideBarState ? (
            <Tooltip placement='right' title='Logout'>
              <Button
                id='adminSidebar-logOut-button'
                type='default'
                onClick={handleLogoutClick}>
                <img src={Logout} />
              </Button>
            </Tooltip>
          ) : (
            <Button
              id='adminSidebar-logOut-button'
              type='default'
              onClick={handleLogoutClick}>
              <img src={Logout} />
              Logout
            </Button>
          )}
        </Link>
      </div>
    </Sider>
  );
};
export default SideBarMenu;
